'use client';

import React from 'react';
import { motion } from 'framer-motion';

interface LineProps {
  direction: 'left' | 'right' | 'top' | 'bottom';
  length?: number;
  thickness?: number;
  duration?: number;
}

const Line: React.FC<LineProps> = ({
  direction,
  length = 100,
  thickness = 2,
  duration = 1,
}) => {
  // Determine if the line is horizontal or vertical
  const isHorizontal = direction === 'left' || direction === 'right';

  // Gradient fading setup (opposite side of expansion)
  const gradientClass = {
    left: 'bg-gradient-to-l from-base-100 to-primary',
    right: 'bg-gradient-to-r from-base-100 to-primary',
    top: 'bg-gradient-to-t from-base-100 to-primary',
    bottom: 'bg-gradient-to-b from-base-100 to-primary',
  }[direction];

  // Set animation origin
  const originClass = {
    left: 'right',
    right: 'left',
    top: 'bottom',
    bottom: 'top',
  }[direction];

  return (
    <motion.div
      initial={{ scaleX: isHorizontal ? 0 : 1, scaleY: isHorizontal ? 1 : 0 }}
      animate={{ scaleX: 1, scaleY: 1 }}
      transition={{ duration, ease: 'easeOut' }}
      className={`relative origin-${originClass} ${gradientClass}`}
      style={{
        width: isHorizontal ? `${length}px` : `${thickness}px`,
        height: isHorizontal ? `${thickness}px` : `${length}px`,
      }}
    />
  );
};

export default Line;
